import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import moment from 'moment'
import styled from 'styled-components'
import { actions } from '../redux/modules/jobDetails'
import { actions as userActions } from '../redux/modules/userActions'
import { actions as employeesActions } from '../redux/modules/employeesActions'
import {
  Input,
  Select,
  Form,
  message,
  Col,
  AutoComplete,
  Icon,
  Button,
  Popconfirm,
  Divider
} from 'antd'
import history from '../history'
import ChildrenJobs from '../components/jobs/ChildrenJobs.js'
import _ from 'lodash'
import { actions as organizationsActions } from '../redux/modules/organizationsActions'
import { actions as companiesActions } from '../redux/modules/companiesActions'
import OrganizationQuickAdd from '../components/organization//OrganizationQuickAdd'
import { convertToOption } from '../util'

import 'react-table/react-table.css'
import 'antd/dist/antd.css'

const ButtonsArea = styled.div`
  padding-bottom: 20px;
`
const propTypes = {}
const Option = Select.Option
const FormItem = Form.Item

class JobDetails extends Component {
  constructor(props) {
    super(props)
    this.props.employeesRefresh()
    this.state = {
      detailShowing: true,
      currentTable: 'Job Attachments',
      confirmDirty: false,
      autoCompleteResult: []
    }
    this.props.getAllCompanies()

    this.props.fetchJobDetails({
      jobId: this.props.match.params.jobId
    })

    this.props.fetchChildrenJobs({
      jobId: this.props.match.params.jobId
    })
    this.props.getAllUsers()
  }

  filterUserList = () => {
    var filteredUsers = []
    if (
      this.props.userActions &&
      this.props.userActions.users &&
      this.props.userActions.users.data
    ) {
      filteredUsers = this.props.userActions.users.data.map(user => {
        const newObj = {
          value: user.id,
          text: `${user.first_name} ${user.last_name}`
        }
        return newObj
      })
    }
    return filteredUsers
  }

  filterEmployeeList = () => {
    var filteredEmployees = []
    if (
      this.props.employeesActions &&
      this.props.employeesActions.payload &&
      this.props.employeesActions.payload.data
    ) {
      filteredEmployees = this.props.employeesActions.payload.data.map(employee => {
        const newObj = {
          value: employee.id,
          text: `${employee.first_name} ${employee.last_name}`
        }
        return newObj
      })
    }
    return filteredEmployees
  }

  getSelectedOrganization = value => {
    const selectedOrganization = this.props.companiesActions.payload.data.find(
      organization => organization.name === value
    )
    return selectedOrganization ? +selectedOrganization.id : +value
  }

  handleSaveJobClick = () => {
    const form = this.props.form
    const { payload } = this.props.jobDetails
    form.validateFields((err, values) => {
      const initialValueAutocompleteIndex = this.filterUserList().findIndex(user => {
        const { payload } = this.props.jobDetails

        return (
          user.text ===
          `${payload.data.assigned_to_first_name} ${payload.data.assigned_to_last_name}`
        )
      })

      const param = {
        // -- job
        type: values.jobType,
        name: values.name,
        description: values.jobDescription,
        updated_by_id: 1,
        organization_id: this.getSelectedOrganization(values.organization_id),
        // -- user
        assigned_to_id: Number.isInteger(parseInt(values.assignedTo, 10))
          ? values.assignedTo
          : this.filterUserList()[initialValueAutocompleteIndex].id,

        maintenance_tech: Number.isInteger(parseInt(values.maintenance_tech, 10))
          ? values.maintenance_tech
          : this.filterEmployeeList()[initialValueAutocompleteIndex].id,
        // -- adress
        city: values.city,
        address1: values.address1,
        address2: values.address2,
        state: values.state,
        zip: values.zip
      }

      if (values.jobType === 'Maintenance/Service') {
        param.status =
          payload.data.status === 'active' || payload.data.status === 'inactive'
            ? payload.data.status
            : 'active'
      } else if (this.props.jobStatus !== false) {
        var statusJobDecoded = ''
        switch (this.props.jobStatus) {
          case 33:
            statusJobDecoded = 'Manufacturing'
            break
          case 66:
            statusJobDecoded = 'Work in Progress'
            break
          case 100:
            statusJobDecoded = 'Complete'
            break
          default:
            statusJobDecoded = 'Design'
            break
        }

        param.status = statusJobDecoded
      }

      this.props.updateJobDetails({
        jobId: this.props.match.params.jobId,
        content: param
      })
      message.success('Job details saved.')
      this.props.handleEditJobClick()
    })
  }

  deleteJob = jobId => {
    this.props.deleteJob({ jobId, userId: this.props.userId })
    message.success('Job deleted.')
    history.push('/jobs')
  }

  inactivateJob = jobId => {
    this.props.inactivateJob({ jobId, userId: this.props.userId })
    message.success('Job inactivated.')
    this.props.fetchJobDetails({
      jobId: this.props.match.params.jobId
    })
  }

  activateJob = jobId => {
    this.props.activateJob({ jobId, userId: this.props.userId })
    message.success('Job activated.')
    this.props.fetchJobDetails({
      jobId: this.props.match.params.jobId
    })
  }

  handleRowJobClick = row => {
    window.location.href = `/jobView/${row.id}/${row.type}`
  }

  handleCreateLinkedJob = () => {
    window.location.href = `/jobs/${this.props.match.params.jobId}`
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.userId
    })
    setTimeout(() => {
      this.props.getAllCompanies()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.companiesActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.companiesActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }

  handleNavigateToLinkedJob = job => {
    console.log('chegou')
    history.push(`/jobView/${job.parent_job_id}/${job.type}`)
    window.location.reload()
  }
  /* End Organization Quick Add */

  render() {
    const { getFieldDecorator } = this.props.form
    const { payload, childrenJobs } = this.props.jobDetails
    const allCompanies =
      this.props.companiesActions &&
      this.props.companiesActions.payload &&
      this.props.companiesActions.payload.data
    const employees = _.get(this.props, 'employeesActions.payload.data')
    if (!payload) {
      return (
        <div>
          <div className="jobsBar">
            Job Details
            <div className="jobsBarAdd">
              <i className="fa fa-pencil-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel">EDIT JOB</div>
            </div>
          </div>
          <div className="jobLoading">
            <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <OrganizationQuickAdd
            modalVisible={this.state.quickAddModalVisibility}
            handleCancel={this.handleCancelQuickAdd}
            handleQuickAddOrganization={this.handleQuickAddOrganization}
            organizartionType={'Client'}
          />
          <div className="jobsBar">
            Job Details
            {!this.props.isEditing && (
              <div className="jobsBarAdd" onClick={() => this.props.handleEditJobClick()}>
                <i className="fa fa-pencil-square" aria-hidden="true" />
                &nbsp;<div className="addJobLabel">EDIT JOB</div>
              </div>
            )}
            {this.props.isEditing && (
              <div className="displayFlex">
                <div className="jobsBarAdd" onClick={() => this.handleSaveJobClick()}>
                  <i className="fa fa-save" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel">SAVE CHANGES</div>
                </div>
                <div className="jobsBarAdd" onClick={() => this.props.handleEditJobClick()}>
                  <i className="fa fa-ban" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel">CANCEL</div>
                </div>
              </div>
            )}
          </div>
          {payload.data ? (
            <div className="jobDetails">
              <Form>
                <div className="row">
                  <div className="col-md-12">
                    <ButtonsArea>
                      <Button
                        className="marginRight10"
                        icon="folder-add"
                        type="default"
                        onClick={() => this.handleCreateLinkedJob()}
                      >
                        Create Linked Job
                      </Button>
                      {(!payload.data.inactive || payload.data.inactive === 0) && (
                        <Popconfirm
                          title="Are you sure you want to INACTIVATE this job?"
                          onConfirm={() => this.inactivateJob(this.props.jobId)}
                          onCancel={this.cancelDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button type="danger" icon="disconnect" className="marginRight10">
                            Inactivate Job
                          </Button>
                        </Popconfirm>
                      )}
                      {payload.data.inactive === 1 && (
                        <Popconfirm
                          title="Are you sure you want to REOPEN this job?"
                          onConfirm={() => this.activateJob(this.props.jobId)}
                          onCancel={this.cancelDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button type="danger" icon="link" className="marginRight10">
                            Reopen Job
                          </Button>
                        </Popconfirm>
                      )}
                      <Popconfirm
                        title="Are you sure you want to delete this job? This is NOT reversible!"
                        onConfirm={() => this.deleteJob(this.props.jobId)}
                        onCancel={this.cancelDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="danger" icon="delete">
                          Delete Job
                        </Button>
                      </Popconfirm>
                    </ButtonsArea>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">CREATED DATE</div>
                    {`${moment(payload.data.created_date).format('M/D/YYYY h:mm:ssa')}`}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">UPDATED DATE</div>
                    {`${moment(payload.data.updated_date).format('M/D/YYYY h:mm:ssa')}`}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">CREATED BY</div>
                    {`${payload.data.created_by_first_name} ${payload.data.created_by_last_name}`}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">UPDATED BY</div>
                    {`${payload.data.updated_by_first_name} ${payload.data.updated_by_last_name}`}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">ID</div>
                    {payload.data.id}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">NAME</div>
                    {!this.props.isEditing && `${payload.data.name}`}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('name', {
                          rules: [
                            {
                              required: true,
                              message: 'Please input the JOB Name!'
                            }
                          ],
                          initialValue: payload.data.name
                        })(<Input id="name" />)}
                      </FormItem>
                    )}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">TYPE</div>
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('jobType', {
                          initialValue: payload.data.type
                        })(
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select a type"
                            optionFilterProp="children"
                            initialValue={payload.data.type}
                            onChange={this.handleChangeSelectType}
                            onFocus={this.handleFocusSelectType}
                            onBlur={this.handleBlurSelectType}
                            filterOption={(input, option) =>
                              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            <Option value="Modernization">Modernization</Option>
                            <Option value="Repair">Repair</Option>
                            <Option value="Specialty">Specialty</Option>
                            <Option value="Material Sale">Material Sale</Option>
                            <Option value="New Construction">New Construction</Option>
                            <Option value="Maintenance/Service">Maintenance/Service</Option>
                          </Select>
                        )}
                      </FormItem>
                    )}
                    {!this.props.isEditing && `${payload.data.type}`}
                  </div>
                  <div className="col-md-3">
                    {payload.data.type === 'Maintenance/Service' && (
                      <div>
                        <div className="jobDetailsHeader">MAINTENANCE TECH</div>
                        {this.props.isEditing && (
                          <FormItem>
                            {getFieldDecorator('maintenance_tech', {
                              initialValue: `${payload.data.maintenance_tech_first_name} ${
                                payload.data.maintenance_tech_last_name
                              }`
                            })(
                              <AutoComplete
                                dataSource={this.filterEmployeeList(employees)}
                                filterOption={(inputValue, option) =>
                                  option.props.children
                                    .toUpperCase()
                                    .indexOf(inputValue.toUpperCase()) !== -1
                                }
                              >
                                <Input
                                  suffix={<Icon type="search" className="certain-category-icon" />}
                                />
                              </AutoComplete>
                            )}
                          </FormItem>
                        )}
                        {payload.data.maintenance_tech === null
                          ? 'N/A'
                          : `${payload.data.maintenance_tech_first_name} ${
                              payload.data.maintenance_tech_last_name
                            }`}
                      </div>
                    )}
                  </div>
                  <div className="col-md-3" />
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">COMPANY NAME</div>
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('organization_id', {
                          initialValue: payload.data.company_name
                        })(
                          <AutoComplete
                            dataSource={convertToOption(allCompanies)}
                            filterOption={(inputValue, option) =>
                              option.props.children
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            placeholder="Search for some Company"
                            width={320}
                            onBlur={this.handleBlurOrganization}
                          >
                            <Input
                              suffix={<Icon type="search" className="certain-category-icon" />}
                            />
                          </AutoComplete>
                        )}
                      </FormItem>
                    )}
                    {!this.props.isEditing && (
                      <Link to={`/companies/${payload.data.company_id}`}>
                        {payload.data.company_name}
                      </Link>
                    )}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">ASSIGNED TO</div>
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('assignedTo', {
                          initialValue: `${payload.data.assigned_to_first_name} ${
                            payload.data.assigned_to_last_name
                          }`
                        })(
                          <AutoComplete
                            dataSource={
                              this.props.userActions &&
                              this.props.userActions.users &&
                              this.filterUserList()
                            }
                            filterOption={(inputValue, option) =>
                              option.props.children
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                          >
                            <Input
                              suffix={<Icon type="search" className="certain-category-icon" />}
                            />
                          </AutoComplete>
                        )}
                      </FormItem>
                    )}
                    {!this.props.isEditing && (
                      <div>
                        {`${payload.data.assigned_to_first_name} ${
                          payload.data.assigned_to_last_name
                        }`}
                      </div>
                    )}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">DESCRIPTION</div>
                    {!this.props.isEditing && `${payload.data.description}`}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('jobDescription', {
                          initialValue: payload.data.description
                        })(<Input id="description" />)}
                      </FormItem>
                    )}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">ADDRESS</div>
                    {!this.props.isEditing && `${payload.data.address1}`}
                    {!this.props.isEditing &&
                      payload.data.address2 &&
                      ` - ${payload.data.address2}`}
                    {!this.props.isEditing && <br />}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('address1', {
                          initialValue: payload.data.address1
                        })(<Input id="address1" placeholder="Address" />)}
                      </FormItem>
                    )}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('address2', {
                          initialValue: payload.data.address2
                        })(<Input id="address2" placeholder="Address (cont)" />)}
                      </FormItem>
                    )}
                    {!this.props.isEditing && `${payload.data.city}, `}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('city', {
                          initialValue: payload.data.city
                        })(<Input id="city" placeholder="City" />)}
                      </FormItem>
                    )}
                    {!this.props.isEditing && `${payload.data.state}`}
                    {!this.props.isEditing && payload.data.zip && ` - ${payload.data.zip}`}
                    <FormItem>
                      {this.props.isEditing && (
                        <Col span={11}>
                          <FormItem>
                            {getFieldDecorator('state', {
                              initialValue: payload.data.state
                            })(<Input id="state" placeholder="State" />)}
                          </FormItem>
                        </Col>
                      )}
                      {this.props.isEditing && (
                        <Col span={2}>
                          <span
                            style={{
                              display: 'inline-block',
                              width: '100%',
                              textAlign: 'center'
                            }}
                          >
                            -
                          </span>
                        </Col>
                      )}
                      {this.props.isEditing && (
                        <Col span={11}>
                          <FormItem>
                            {getFieldDecorator('zip', {
                              initialValue: payload.data.zip
                            })(<Input id="zip" placeholder="Zip" />)}
                          </FormItem>
                        </Col>
                      )}
                    </FormItem>
                  </div>
                </div>
              </Form>
              <Divider />
              <div className="row">
                <div className="col-md-2">
                  <div className="jobDetailsHeader">PARENT JOB ID</div>
                  {payload.data.parent_job_id === null ? (
                    'N/A'
                  ) : (
                    <Button
                      type="link"
                      onClick={() => this.handleNavigateToLinkedJob(payload.data)}
                    >
                      {payload.data.parent_job_id}
                    </Button>
                  )}
                </div>
                <div className="col-md-2">
                  {' '}
                  <div className="jobDetailsHeader">LEGACY JOB ID</div>
                  {payload.data.legacy_job_id === null ? 'N/A' : payload.data.legacy_job_id}
                </div>
                <div className="col-md-2">
                  <div className="jobDetailsHeader">LEAD ID</div>
                  {payload.data.lead_id === null ? (
                    'N/A'
                  ) : (
                    <Link to={`/lead/${payload.data.lead_id}`}>{payload.data.lead_id}</Link>
                  )}
                </div>
                <div className="col-md-2">
                  <div className="jobDetailsHeader">ESTIMATE ID</div>
                  {payload.data.estimate_id === null ? (
                    'N/A'
                  ) : (
                    <Link
                      to={`/lead/${payload.data.lead_id}/estimates/edit/${
                        payload.data.estimate_id
                      }`}
                    >
                      {payload.data.estimate_id}
                    </Link>
                  )}
                </div>
                <div className="col-md-2">
                  <div className="jobDetailsHeader">PROPOSAL ID</div>
                  {payload.data.proposal_id === null ? (
                    'N/A'
                  ) : (
                    <Link
                      to={`/lead/${payload.data.lead_id}/proposals/edit/${
                        payload.data.proposal_id
                      }`}
                    >
                      {payload.data.proposal_id}
                    </Link>
                  )}
                </div>
                <div className="col-md-2">
                  <div className="jobDetailsHeader">CONTRACT ID</div>
                  {payload.data.contract_id === null ? (
                    'N/A'
                  ) : (
                    <Link
                      to={`/lead/${payload.data.lead_id}/contracts/edit/${
                        payload.data.contract_id
                      }`}
                    >
                      {payload.data.contract_id}
                    </Link>
                  )}
                </div>
              </div>
              {childrenJobs &&
                childrenJobs.data.length > 0 && (
                  <ChildrenJobs
                    handleRowJobClick={this.handleRowJobClick}
                    childrenJobs={childrenJobs}
                  />
                )}
            </div>
          ) : (
            <div>something went wrong</div>
          )}
        </div>
      )
    }
  }
}

const mapStateToProps = (
  { jobDetails, userActions, organizationsActions, companiesActions, employeesActions },
  ownProps
) => ({
  jobDetails,
  userActions,
  employeesActions,
  organizationsActions,
  companiesActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      actions,
      userActions,
      employeesActions,
      organizationsActions,
      companiesActions
    ),
    dispatch
  )
})

JobDetails.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobDetails)))



// WEBPACK FOOTER //
// ./src/components/JobDetails.js